import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAccessToken } from "@/hooks";
import { CustomerVaultsApi } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";

interface UseVaultCreateParams {
  userId: number;
  tokenId: string;
  transactionId: string;
  tenantId: number;
  isDefault: boolean;
}

export const useVaultCreate = () => {
  const accessToken = useAccessToken();
  const queryClient = useQueryClient();

  const { mutate, mutateAsync, isPending, isSuccess, isError, error } =
    useMutation({
      mutationFn: async ({
        userId,
        tokenId,
        transactionId,
        tenantId,
        isDefault,
      }: UseVaultCreateParams) => {
        if (!accessToken) {
          throw new Error("Authentication token is required");
        }

        const service = createAuthenticatedApi(
          CustomerVaultsApi,
          accessToken,
        );

        await service.apiUsersUserIdVaultPost({
          userId,
          createCustomerVaultRequest: { tokenId, transactionId, isDefault },
          xTenantID: tenantId,
        });

        return { userId };
      },
      onSuccess: ({ userId }) => {
        queryClient.invalidateQueries({
          queryKey: [QueryKeys.CustomerVaults, userId],
        });
      },
    });

  return { mutate, mutateAsync, isPending, isSuccess, isError, error };
};
